<h1 mat-dialog-title>{{ dialogTitle }}</h1>
<mat-dialog-content [formGroup]="importFormGroup">
    <mat-form-field fxFill>
        <mat-label>Date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="From" />
            <input matEndDate formControlName="end" placeholder="To" />
        </mat-date-range-input>
        <button *ngIf="isDateSelected()" matSuffix mat-icon-button aria-label="Clear" (click)="clearDates()">
            <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker [dateClass]="dateClass()" [startAt]="startAt" #picker></mat-date-range-picker>
    </mat-form-field>
    <mat-form-field fxFill>
        <mat-label>Employee</mat-label>
        <input matInput formControlName="employee" [matAutocomplete]="autoEmployees" />
        <button *ngIf="isEmployeeSelected()" matSuffix mat-icon-button aria-label="Clear" (click)="clearEmployee()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
    <mat-autocomplete #autoEmployees="matAutocomplete">
        <mat-option
            *ngFor="let employee of filteredEmployees; trackBy: trackBy"
            [value]="this.getEmployeeName(employee)">
            {{ this.getEmployeeName(employee) }}
        </mat-option>
    </mat-autocomplete>
    <mat-form-field fxFill>
        <mat-label>Client-Project</mat-label>
        <input matInput formControlName="clientProject" aria-label="Client-Project" [matAutocomplete]="autoClients" />
        <button *ngIf="isClientSelected()" matSuffix mat-icon-button aria-label="Clear" (click)="clearClient()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
    <fieldset>
        <legend>Timesheets protection overrides</legend>
        <div fxLayout="row" fxFlex="100">
            <mat-checkbox fxFlex="45" formControlName="edited"> Overwrite manually edited timecards </mat-checkbox>
            <mat-checkbox fxFlex="45" formControlName="deleted">
                Restore soft-deleted timecards from Jira
            </mat-checkbox>
        </div>
    </fieldset>
    <mat-autocomplete #autoClients="matAutocomplete">
        <mat-option
            *ngFor="let project of filteredTimesheetProjects; trackBy: trackBy"
            [value]="this.getProjectName(project)"
            >{{ this.getProjectName(project) }}</mat-option
        >
    </mat-autocomplete>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" mat-dialog-close (click)="cancelDialog()">
        <span>Cancel</span>
    </button>
    <button mat-flat-button color="primary" (click)="saveImport()" [disabled]="!isValid()">
        <span>Backfill</span>
    </button>
</mat-dialog-actions>
